import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from '@ag-grid-community/angular';
import { AgGridComponentsModule } from 'src/app/ag-grid-components/ag-grid-components.module';
import { DataGridModule } from 'src/app/data-grid/data-grid.module';
import { ComponentsModule } from 'src/app/components/components.module';
import { AngularMaterialModule } from './../angular-material/angular-material.module';
import { DetailModule } from './../detail/detail.module';
import { ProductBreakdownPanelComponent } from './product-breakdown-panel/product-breakdown-panel.component';
import { SkuBreakdownPanelComponent } from './sku-breakdown-panel/sku-breakdown-panel.component';
import { AddEventDialogComponent } from './presentational/add-event-dialog/add-event-dialog.component';
import { BreakdownHeaderComponent } from './presentational/breakdown-header/breakdown-header.component';
import { SeasonsDialogComponent } from './presentational/seasons-dialog/seasons-dialog.component';



@NgModule({
  declarations: [
    BreakdownHeaderComponent,
    AddEventDialogComponent,
    ProductBreakdownPanelComponent,
    SkuBreakdownPanelComponent,
    SeasonsDialogComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    DataGridModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    AgGridComponentsModule,
    AgGridModule,
    DetailModule,
  ],
  exports:[
    BreakdownHeaderComponent
  ]
})
export class BreakdownModule { }
